import React, { useContext, useState } from 'react'
import {
  Box, IcoMoon, Text, Image, KeyboardArrowDownIcon, KeyboardArrowUpIcon
} from '@usap/uicomponents'
import { SelectedItemsContext } from '../../../../contexts/SelectedItemsContextProvider'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

const MultiItemBox = props => {
  const {
    setItemImage,
    activeCount,
    isDesktop,
  } = props

  const [isShowBox, setShowBox] = useState('none')
  const [icoMoonChar, setIcoMoon] = useState(KeyboardArrowDownIcon)
  const selectedItemsContextData = useContext(SelectedItemsContext)
  const { orderItems } = selectedItemsContextData

  const isWmoEnabled = useWmoEnabled()

  if (orderItems.length < 2) return null

  const counter = activeCount
  const itemsCount = orderItems.length

  const setOpacity = location => {
    if ((counter - 1) < location) {
      return { textAlign: 'center', opacity: '50%' }
    }
    return { textAlign: 'center' }
  }

  const showHideBox = () => {
    if (isShowBox === 'flex') {
      setShowBox('none')
      setIcoMoon(KeyboardArrowDownIcon)
    } else {
      setShowBox('flex')
      setIcoMoon(KeyboardArrowUpIcon)
    }
  }

  return (
    <>
      <Box
        pad="medium"
        justify="start"
        direction="column"
        round="6px"
        border={{
          size: 'xsmall',
          color: '#E0E0E0',
          side: 'all',
        }}
        margin={{ bottom: isDesktop ? (isWmoEnabled ? '16px' : '0px'): '16px' }}
      >
        {/* Upper Box Pagination with arrow */}
        <Box
          width="100%"
          alignContent="center"
          alignSelf="center"
          direction="row"
          display="flex"
        >
          <Box
            alignContent="start"
            alignSelf="start"
            width="100%"
          >
            <Text
              size="small"
              color="#333333"
              style={{ fontWeight: 400 }}
            >
              Return
              {' '}
              <strong>{counter}</strong>
              {' '}
              of
              {' '}
              {itemsCount}
            </Text>
          </Box>
          <Box
            alignContent="end"
            alignSelf="end"
            onClick={() => showHideBox()}
          >
            <IcoMoon icon={icoMoonChar} height="24px" />
          </Box>
        </Box>
        {/* Upper Box Pagination with arrow */}
        <Box
          width="100%"
          alignContent="center"
          alignSelf="center"
          direction="row"
          style={{
            display: isShowBox,
            flexWrap: 'wrap',
            padding: '5px',
            justifyContent: 'flex-start',
          }}
        >
          {Object.values(orderItems).map((item, i) => (
            <Box
              key={item.sku}
              width="80px"
              height="80px"
              alignContent="center"
              alignSelf="center"
              style={setOpacity(i)}
              margin={{ horizontal: '25px', vertical: '8px' }}
            >
              <Image
                height="56px"
                width="56px"
                className="lazyload"
                src={setItemImage(item.ImageURL, item.sku)}
                fit="contain"
                cloudinaryParams="h_56,w_56"
                style={{
                  alignSelf: 'center',
                  cursor: 'pointer',
                }}
              />
              <Text
                size="small"
                color="#333333"
                style={{ fontWeight: 400 }}
              >
                Return
                {' '}
                <strong>{i + 1}</strong>
                {' '}
                of
                {' '}
                {itemsCount}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  )
}

export default MultiItemBox
